import React, { useState, createContext, useContext } from 'react';
const MenuContext = createContext();

export const DataTableWrapper = ({ children }) => {
  const [openMenuCandidateId, setOpenMenuCandidateId] = useState(null);
  return (
    <MenuContext.Provider value={{ openMenuCandidateId, setOpenMenuCandidateId }}>
      {children}
    </MenuContext.Provider>
  );
};

export const useMenuContext = () => useContext(MenuContext);
